import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { FormControl } from '../../../../ui/components/pure/form-control/form-control.component';
import { TextButton } from '../../../../ui/components/pure/text-button/text-button.component';
import { TextField } from '../../../../ui/components/pure/text-field/text-field.component';
import { mobilePhoneValidator } from '../../../../ui/util/mobile-phone.validator';

interface CourierLoginTestingForm {
  mobile: string;
}

export interface CourierLoginTestingProps {
  onSubmit: (mobile: string) => void;
}

export function CourierLoginForm(props: CourierLoginTestingProps) {
  const form = useForm<CourierLoginTestingForm>({
    defaultValues: {
      mobile: ''
    }
  });

  // Additional custom validation to ensure the mobile number is a valid mobile number
  // from either New Zealand or Australia
  function validate(mobile: string) {
    const len = mobile.length;

    // We don't want to show an error message if the field is empty
    if (len === 0) {
      return true;
    }

    const isValid = mobilePhoneValidator(mobile);
    const validCountryCodes = ['+64', '+61'];
    const isValidCountryCode = validCountryCodes.some((code) => mobile.startsWith(code));

    if (!isValidCountryCode || !isValid) {
      return 'Please enter a valid international mobile number from New Zealand or Australia';
    }

    return true;
  }

  return (
    <form onSubmit={form.handleSubmit((form) => props.onSubmit(form.mobile))}>
      <Grid container spacing={2} style={{ marginBottom: '32px' }}>
        <Grid style={{ minWidth: '316px' }}>
          <FormControl
            control={form.control}
            name="mobile"
            required
            rules={{ validate }}
            Component={TextField}
            ComponentProps={{
              type: 'tel',
              textFieldVariant: 'secondarySolid' as const,
              textColorOverride: 'white',
              shrinkLabel: false,
              placeholder: 'Mobile phone number',
              style: { width: '100%' }
            }}
          />
        </Grid>
        <Grid>
          <TextButton variant="contained" color="secondary" type="submit">
            Submit
          </TextButton>
        </Grid>
      </Grid>
    </form>
  );
}
